import styled, { createGlobalStyle } from 'styled-components';
import { colors } from '../../layout/design';

export const GlobalStyled = createGlobalStyle`
  body {
    background-color: ${colors.lighterGrey};
  }
`;

export const OrderPage = styled.div`
  width: auto;
`;

export const ArrowBack = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  height: 25px;

  & svg {
    transform: rotate(180deg);
  }
`;
